import {
  ADD_GAME_ACTIVITY,
  CLEAR_GAME_STATE,
  SET_SELECTED_STAGE,
  SET_SELECTED_BLOCK,
  SET_GAME_CASE,
  SET_GAME_STATUS,
  SAVE_HISTORY_TAKING,
  SET_GAME_PAGE,
  ADD_CHECKLIST,
  DELETE_CHECKLIST,
  UPDATE_CHECKLIST,
  SET_PRESENTATION_FLAG,
} from "../types";

export const setGameStageAction = (data) => {
  return {
    type: SET_SELECTED_STAGE,
    payload: { stage: data },
  };
};

export const setGameBlockAction = (data) => {
  return {
    type: SET_SELECTED_BLOCK,
    payload: { block: data },
  };
};

export const setGameCaseAction = (data) => {
  return {
    type: SET_GAME_CASE,
    payload: { case: data },
  };
};

export const setGameStatusAction = (status) => {
  return {
    type: SET_GAME_STATUS,
    payload: { status },
  };
};

export const setGamePageAction = (data, onViewStatus) => {
  return {
    type: SET_GAME_PAGE,
    payload: { page: data, onViewStatus: onViewStatus },
  };
};

export const addGameActivityAction = (questionType, questionId) => {
  const timestamp = new Date().getTime();

  return {
    type: ADD_GAME_ACTIVITY,
    payload: {
      questionType,
      questionId,
      timestamp,
    },
  };
};

export const saveHistoryTakingAction = (history) => {
  return {
    type: SAVE_HISTORY_TAKING,
    payload: history,
  };
};

export const clearGameStateAction = () => {
  return {
    type: CLEAR_GAME_STATE,
    payload: {},
  };
};

export const addChecklistAction = (category, id, type, item, result) => {
  return {
    type: ADD_CHECKLIST,
    payload: {
      category,
      details: {
        id,
        type,
        item,
        result,
      },
    },
  };
};

export const deleteCheckListAction = (category, id) => {
  return {
    type: DELETE_CHECKLIST,
    payload: {
      category,
      id,
    },
  };
};

export const updateCheckListAction = (category, id, type, item, result) => {
  return {
    type: UPDATE_CHECKLIST,
    payload: {
      category,
      details: {
        id,
        type,
        item,
        result,
      },
    },
  };
};

export const setPresentationFlagAction = (flag) => {
  return {
    type: SET_PRESENTATION_FLAG,
    payload: flag,
  };
};
